import  {ReactComponent as Wave1}  from "./1wave.svg"
import {ReactComponent as Wave2} from "./2wave.svg"
import {ReactComponent as Wave3} from "./3wave.svg"
import {ReactComponent as Wave4} from "./4wave.svg"

const Waves = {
    Wave1,
    Wave2,
    Wave3,
    Wave4,
};

export default Waves;